import * as types from './mutations-types'
import memberCouponApi from '../../../../api/wx-member/member-coupon/member-coupon'
import FormatTableFieldUtils from '../../../../common/utils/format-table-field-util'
import * as DictionaryConstants from '../../../../constants/DictionaryConstants'
import * as DataTypeConstants from '../../../../constants/DataTypeConstants'

export default {
  getCouponByCouponUseStatus: ({commit}, data) => {
    memberCouponApi.getCouponByCouponUseStatus(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponType',
            fieldPropName: 'couponTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result, params).then(res => {
          result = res
          if (data.couponUseStatus === DictionaryConstants.COUPON_USE_STATUS_UNWRITTEN) {
            commit(types.COUPON_INFO, result)
          } else {
            commit(types.COUPON_INFO_EXPIRED, result)
          }
        })
      })
  },
  updateCoupon: ({commit}, data) => {
    commit(types.UPDATE_COUPON_INFO, data)
  },
  updateCouponFalse: ({commit}, data) => {
    commit(types.UPDATE_COUPON_INFO_FALSE, data)
  },
  getUserReasonCouponListByMemberId: ({commit}, data) => {
    memberCouponApi.getUserReasonCouponListByMemberId(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponType',
            fieldPropName: 'couponTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result, params).then(res => {
          result = res
          commit(types.COUPON_INFO_EXPIRED, result)
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-coupon/store/actions.js